"use client";

import useBootstrapClient from "@/features/hooks/useBootstrapClient";
import { PageContainer } from "@/client/layout/PageContainer";
import { BatchTaskProvider } from "../storyboard/batch/context";
import BatchTaskWorkspace from "../storyboard/batch/components/BatchTaskWorkspace";

interface StoryboardBatchPageClientProps {
  locale: string;
}

const StoryboardBatchPageClient: React.FC<StoryboardBatchPageClientProps> = ({ locale }) => {
  void locale;
  useBootstrapClient();

  return (
    <BatchTaskProvider>
      <PageContainer>
        <div className="flex flex-col gap-3 flex-1 min-h-0">
          <BatchTaskWorkspace />
        </div>
      </PageContainer>
    </BatchTaskProvider>
  );
};

export default StoryboardBatchPageClient;
